import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

type InfoField = Extract<MaintenanceChecklistField, { type: 'info' }>;

type Props = {
  field: InfoField;
};

export function ChecklistInfoField({ field }: Props) {
  return (
    <div className="rounded-md border border-dashed bg-muted/40 p-3 text-sm">
      <p className="font-medium">{field.label}</p>
      <p className="text-muted-foreground">{field.content}</p>
    </div>
  );
}
